module.exports = __webpack_public_path__ + "img/contrSlope-nav.5ecc15f1.svg";